import { Authentication, Provider } from '@cian/authentication-widget';
import { disabledSocials } from './constants';
import { useAuthContext } from 'shared/hooks/useAuthContext';

export const AuthenticationContainer = () => {
  const { authContext } = useAuthContext();

  return (
    <Provider context={authContext}>
      <Authentication disabledSocials={disabledSocials} />
    </Provider>
  );
};
